// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"200":"coin","982":"ktoa","997":"ppomppu"}[chunkId] + "." + {"200":"47c5127c","982":"caf22b3f","997":"98d4786f"}[chunkId] + ".css";
};